import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Ph = ({ children }) => <span className="ph" title="Contenuto segnaposto da sostituire">{children}</span>;

export const Eyebrow = ({ n, children, className = "" }) => (
  <p className={`eyebrow flex items-center gap-3 ${className}`}>
    {n && <span className="font-serif text-sm tracking-normal">{n}</span>}
    <span className="h-px w-8 bg-teal/50" aria-hidden="true" />
    <span>{children}</span>
  </p>
);

const base = "group inline-flex items-center justify-between gap-3 whitespace-nowrap px-7 py-4 text-sm font-medium tracking-[0.06em] transition-colors duration-500";
const styles = {
  dark: "bg-ink text-paper hover:bg-teal",
  teal: "bg-teal text-mint hover:bg-ink",
  outline: "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-paper",
  light: "bg-paper text-ink hover:bg-mint",
  ghostLight: "border border-paper/30 text-paper hover:bg-paper hover:text-ink",
};

export const Cta = ({ to, href, children, variant = "dark", className = "", testid, ...rest }) => {
  const cls = `${base} ${styles[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
    </>
  );
  if (href) return <a href={href} className={cls} data-testid={testid} {...rest}>{inner}</a>;
  return <Link to={to} className={cls} data-testid={testid} {...rest}>{inner}</Link>;
};

export const PageHead = ({ eyebrow, lines, intro, testid }) => {
  return { eyebrow, lines, intro, testid };
};
